import React from 'react';
import ReactDOM from 'react-dom/client';
import SignToEnglishApp from './SignToEnglishApp';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SignToEnglishApp />
  </React.StrictMode>
);
